import { ShopsView } from '@/views/Shops/Shops.view';
import { withPreRenderSettings } from '@/utils/hocs';
import NoSsr from '@/components/NoSsr/NoSsr';

function ShopsPage() {
  return (
    <NoSsr>
      <ShopsView />
    </NoSsr>
  );
}

ShopsPage.getInitialProps = withPreRenderSettings(() => ({}));

export default ShopsPage;
